import { Attachment } from '@/library/types/files';
import { useCallback, useReducer } from 'react';
import reducer, { INITIAL_STATE } from './store/reducer';
import TYPES, { RotateDirectionType } from './store/types';

const useGallery = () => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  const setGalleryFiles = useCallback((files: (Attachment | undefined)[] = []) => {
    dispatch({
      type: TYPES.SET_GALLERY_FILES,
      payload: files.filter((a): a is Attachment => Boolean(a))
    });
  }, []);

  const updateGalleryFile = useCallback((fileId: number | string, updatedFile: Attachment) => {
    dispatch({
      type: TYPES.UPDATE_GALLERY_FILE,
      payload: { fileId, updatedFile }
    });
  }, []);

  const toggleGallery = useCallback(async (isOpen: boolean) => {
    dispatch({ type: TYPES.TOGGLE_GALLERY, payload: isOpen });
  }, []);

  const setGalleryCurrentFile = useCallback((file: Attachment) => {
    dispatch({ type: TYPES.SET_SELECTED_FILE, payload: file });
  }, []);

  const setGalleryRotateDirection = useCallback((direction: RotateDirectionType) => {
    dispatch({ type: TYPES.SET_ROTATE_DIRECTION, payload: direction });
  }, []);

  return {
    ...state,
    setGalleryFiles,
    updateGalleryFile,
    toggleGallery,
    setGalleryCurrentFile,
    setGalleryRotateDirection
  };
};

export type GalleryController = ReturnType<typeof useGallery>;

export default useGallery;
